(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  if (typeof window.bindAncientAddToCartButtons === 'function') {
    document.querySelectorAll('.ae-related-products').forEach((section) => {
      window.bindAncientAddToCartButtons(section);
    });
  }

  document.querySelectorAll('[data-ae-rp-slider]').forEach((slider) => {
    const viewport = slider.querySelector('[data-ae-rp-viewport]');
    const track = slider.querySelector('[data-ae-rp-track]');
    const slides = Array.from(track?.children || []);
    const prev = slider.querySelector('[data-ae-rp-prev]');
    const next = slider.querySelector('[data-ae-rp-next]');
    const progress = slider.querySelector('[data-ae-rp-progress]');
    if (!viewport || !track || !slides.length) return;

    let index = 0;
    const slideSize = () => {
      const slide = slides[0];
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    };
    const visibleCount = () => {
      const w = viewport.getBoundingClientRect().width;
      return Math.max(1, Math.floor(w / slideSize()));
    };
    const maxIndex = () => Math.max(0, slides.length - visibleCount());

    const update = () => {
      const offset = index * slideSize();
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
      if (progress) {
        const total = maxIndex();
        const ratio = total <= 0 ? 1 : (index + visibleCount()) / slides.length;
        progress.style.width = `${Math.min(100, Math.max(12, ratio * 100))}%`;
      }
    };

    prev?.addEventListener('click', () => { index = Math.max(0, index - 1); update(); });
    next?.addEventListener('click', () => { index = Math.min(maxIndex(), index + 1); update(); });
    window.addEventListener('resize', () => { index = Math.min(index, maxIndex()); update(); });
    update();
  });
});
